import { defineComponent as _defineComponent } from 'vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import '~/assets/css/swiper.css';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data: {
    items: {
      img?: string;
      title: string;
      description?: string;
      image?: any;
      slug?: string;
    }[];
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppPromotions',
  props: {
    data: null
  },
  setup(__props: any) {



const swiperOption = {
  preloadImages: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-button-next-custom',
    prevEl: '.swiper-button-prev-custom',
  },
};

return { __sfc: true,swiperOption, Swiper, SwiperSlide, CdnImg }
}

})